import React, { useContext } from 'react';
import get from 'lodash/get';
import styled from 'styled-components';

import FormContext from 'src/presentation/contexts/FormContext';
import { Body, Row, Section } from 'src/presentation/components/forms/Layout';
import Input, { InputType } from 'src/presentation/components/forms/Input';
import RadioGroup from 'src/presentation/components/forms/RadioGroup';
import { H1 } from '@ad-scripts/presentation/components/common/headers';

const ChatThrottlingSection = () => {
  const { workingState } = useContext(FormContext);
  const address = get(workingState, 'address');
  const header = `Control ${address} Incoming Chat Volume`;
  const isAutoThrottlingEnabled = get(workingState, 'configuration.throttling.autoThrottlingEnabled');
  const description = (
    <span>
      Manage incoming chats with throttling. Auto throttling turns chat off when the customer’s estimated wait time
      exceeds the threshold. Manual throttling allows you to set the percentage of chat requests to agents. To learn
      more, visit our{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://help.gladly.com/docs/control-chat-volume/">
        Help Center.
      </a>{' '}
    </span>
  );

  return (
    <>
      <H1>{header}</H1>
      <Body data-aid={'editor'}>
        <Section description={description}>
          <Row>
            <RadioGroup
              options={[
                { label: 'Auto Throttle', value: true },
                { label: 'Manual Throttle', value: false },
              ]}
              data-aid={`chatThrottling-autoThrottlingEnabled-switch`}
              attr="configuration.throttling.autoThrottlingEnabled"
              label="Throttling"
            />
          </Row>
          <Row>{renderThrottlingSection(!!isAutoThrottlingEnabled)}</Row>
        </Section>
      </Body>
    </>
  );
};

function renderThrottlingSection(isAutoThrottlingEnabled: boolean) {
  if (isAutoThrottlingEnabled) {
    return (
      <StyledInput
        data-aid={`autoThrottlingEnabled-autoThrottlingThreshold-input`}
        description="Longest Estimated Wait Time (in seconds)"
        attr="configuration.throttling.autoThrottlingThreshold"
        placeholder="0"
        type={InputType.number}
      />
    );
  }
  return (
    <StyledInput
      data-aid={`chatThrottling-percentageRollout-input`}
      description="Set chat request volume (by percentage)"
      attr="configuration.throttling.percentageRollout"
      placeholder="0"
      type={InputType.number}
    />
  );
}

export default ChatThrottlingSection;

const StyledInput = styled(Input)`
  max-width: 80px;
`;
